export var IssuerKey;
(function (IssuerKey) {
    IssuerKey["LYMPID"] = "LYMPID";
    IssuerKey["TRADEVEST"] = "TRADEVEST";
    IssuerKey["COBU"] = "COBU";
})(IssuerKey || (IssuerKey = {}));
export const ISSUER_ASSET_STATUS_OVERRIDES = ['soon', 'open', 'closed'];
export const BRAND_STEPS_MAX = 6;
export const BRAND_GLOSSARY_MAX = 12;
//# sourceMappingURL=issuer.types.js.map